import { SignUp } from '@clerk/clerk-react';

export function SignUpPage() {
  return (
    <main className="page page-centered">
      <SignUp signInUrl="/sign-in" forceRedirectUrl="/dashboard" />
    </main>
  );
}
